import { Component, OnInit } from "@angular/core";
import { CartService } from "src/app/core/services/cart.service";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router";
import { OrderService } from "src/app/core/services/order.service";
import { UserService } from "src/app/core/services/user.service";

@Component({
  selector: "app-cart",
  templateUrl: "./cart.component.html",
  styleUrls: ["./cart.component.css"],
})
export class CartComponent implements OnInit {
  public productList: any[];
  product: any;
  closeResult = "";
  modalReference: NgbModalRef;
  titleButton = "ENVIAR PEDIDO.";
  
  // Campos del cliente
  nombre: string = '';
  telefono: string = '';
  direccion: string = ''; // Nuevo campo para dirección
  correo: string = ''; // Nuevo campo para correo
  
  loading=false;
  existeCliente = false;
  constructor(
    private modalService: NgbModal,
    private cartService: CartService,
    private orderService: OrderService,
    private toastrService: ToastrService,
    private userService:UserService,
    private router: Router
  ) { }

  async ngOnInit() {
    this.loading=true;
    this.orderService.validateSession();
    await this.orderAvaliable();
    this.productList = this.cartService.getProductList();
    if (!this.cartService.validateNewProducts()) {
      this.titleButton = "Pagar";
    }
    let client = this.userService.getClient();
    if(client){
      this.nombre=client.name;
      this.telefono=client.tel;
      this.existeCliente=true;
    }
  }

  async orderAvaliable() {
    if (this.orderService.getOrderNumberSession() > 0) {
      let status = await this.orderService.getOrderAvailable();
      if (!status) {
        this.toastrService.info("La orden ya fue facturada");
        this.router.navigate(["/inicio"]);
        this.cartService.clearCart();
        return;
      }

      let order = await this.orderService.getOrdenMesa();
      this.orderService.updateOrder(order[0]);
    }
    this.loading=false;
  }

  getPrecio(product: any): number {
    return parseFloat(product.precio) + parseFloat(product.extras);
  }

  getPrecioTotal(product: any): number {
    return (
      parseFloat(product.precio) + parseFloat(product.extras) * product.cantidad
    );
  }

  getModificadoresStrin(product: any): string {
    let stringModificadores: string = "";
    product.modificadores.forEach((element) => {
      element.modificadores.forEach((modificador) => {
        if (modificador.seleccionado) {
          if (stringModificadores.length > 0) {
            stringModificadores += ", " + modificador.nombre;
          } else {
            stringModificadores += modificador.nombre;
          }
        }
      });
    });
    return stringModificadores;
  }

  getTotal(): number {
    let total: number = 0;
    if(this.productList){
      this.productList.forEach((element) => {
        total +=
          (parseFloat(element.precio) + parseFloat(element.extras)) *
          element.cantidad;
      });
    }
    return total;
  }

  updateProductoList() {
    this.cartService.refreshProductList(this.productList);
  }

  removeProduct() {
    if (this.product) {
      let index: number = this.productList.indexOf(this.product);
      if (index > -1) {
        this.productList.splice(index, 1);
        if (this.cartService.refreshProductList(this.productList)) {
          this.productList = this.cartService.getProductList();
          this.modalReference.close();
          this.toastrService.success(
            "Produto eliminado con exito del carrito",
            "Ok"
          );
        } else {
          this.toastrService.warning(
            "Ocurrio un conflito al intentar eliminar el producto del carrito, intenta nuevamente",
            "Cuidado!"
          );
        }
      } else {
        this.toastrService.warning(
          "Ocurrio un conflito al intentar eliminar el producto del carrito, intenta nuevamente",
          "Cuidado!"
        );
      }
    } else {
      this.toastrService.warning(
        "Ocurrio un conflito al intentar eliminar el producto del carrito, intenta nuevamente",
        "Cuidado!"
      );
    }
  }

  open(content, product: any) {
    this.product = product;
    this.modalReference = this.modalService.open(content);
    this.modalReference.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  public processOrder(modal: any) {
    if (!this.cartService.validateProductsOrderExist() && modal) {
      this.toastrService.info("No hay productos");
      this.router.navigate(["/inicio"]);
      return;
    }
    if (this.cartService.validateNewProducts() && modal) {
      this.modalReference = this.modalService.open(modal);
      return;
    }
    if (
      !modal &&
      (this.nombre.trim() === '' ||
      String(this.telefono).trim() === '' || 
        this.direccion.trim() === '')
    ) {
      this.toastrService.warning(
        'Favor ingresa un nombre, teléfono y dirección.',
        'Datos incompletos'
      );
      return;
    }
    if (!modal) {
      this.userService.setClient({
        name: this.nombre,
        tel: this.telefono,
        address: this.direccion, 
      });
      this.modalReference.close();
      this.router.navigate(["/finalizar/" + 1]);
      return;
    }
    this.router.navigate(["/finalizar"]);
  }
  

}
